import React, { useEffect, useState, useMemo } from 'react'
import MDButton from 'components/MDButton'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices, useUploadImage } from 'hook/services'
import { useNavigate, useParams } from 'react-router-dom'
import Editor from 'components/editor'
import { Button, Checkbox, FormControlLabel, Stack, Autocomplete, TextField } from '@mui/material'

const EditModal = ({ data, handleRefresh, category, paths }) => {
  console.log(paths, 'paths in edit modal1')
  const AppService = useAppServices()
  const [openEditProduct, setOpenEditProduct] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [svgIcon, setSvgIcon] = useState(null)
  const [description, setDescription] = useState(data.description)
  const [selectedPath, setSelectedPath] = useState(null)
  const [searchInput, setSearchInput] = useState('')
  const uploadImage = useUploadImage()
  const { page_id, type } = useParams()

  console.log(page_id, 'params1212')

  const handleModal = () => {
    setOpenEditProduct(true)
    // Set initial selected path based on existing data
    if (data.paths && data.paths.length > 0) {
      const existingPath = data.paths[0]
      const matchedPath = pathOptions.find(option =>
        option.value === existingPath.path || option.label === existingPath.name
      )
      setSelectedPath(matchedPath || null)
    }
  }

  const closeEditProduct = () => {
    setOpenEditProduct(false)
    setSelectedPath(null)
    setSearchInput('')
  }

  const handleSvgUpload = (e) => {
    setSvgIcon(e.target.files[0])
  }

  // Transform paths for Autocomplete
  const pathOptions = useMemo(() => {
    return paths?.map(path => ({
      label: path.name,
      value: path.path,
      ...path
    })) || []
  }, [paths])

  // Filter options based on search input
  const filteredOptions = useMemo(() => {
    if (!searchInput) return pathOptions
    return pathOptions.filter(option =>
      option.label.toLowerCase().includes(searchInput.toLowerCase()) ||
      option.value.toLowerCase().includes(searchInput.toLowerCase())
    )
  }, [pathOptions, searchInput])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)
    let image_response = data.image
    if (e.target?.image?.files?.[0]) {
      const { response } = await uploadImage({
        file: e.target?.image?.files?.[0],
        desiredPath: `app/logo/image`,
      })
      if (response) {
        image_response = response.data
      }
    }

    // Prepare the paths array for payload
    const pathsPayload = selectedPath ? [
      {
        name: selectedPath.label,
        path: selectedPath.value
      }
    ] : []

    const payload = {
      _id: data._id,
      name: e.target.name.value,
      description,
      image: image_response,
      video_path: e.target.video_path.value,
      page_path: e.target.page_path.value,
      type: type,
      status: e.target.status.value,
      points: e.target.points.value,
      category_id: page_id,
      custom_buttons: e.target.custom_buttons.checked,
      paths: pathsPayload, // Add the paths array to payload
    }

    console.log(payload, 'payload')

    const { response } = await AppService.onboarding_list.update({ payload })
    console.log(response, 'response')

    if (response) {
      setProcessing(false)
      closeEditProduct()
      handleRefresh()
    }
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handleModal}>
        Edit
      </MDButton>
      <MDModal open={openEditProduct} onClose={closeEditProduct}>
        <MDBox>
          <MDBox
            component="form"
            onSubmit={handleSubmit}
            role="form"
            sx={style}
            encType="multipart/form-data"
          >
            <MDTypography variant="h5" mb={2}>
              Edit Onboarding
            </MDTypography>

            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth required defaultValue={data.name} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
              <Editor handleChange={setDescription} data={description} />
            </MDBox>

            {/* Path Selection with Search */}
            <MDBox mb={2}>
              <MDTypography variant="button">Select Path</MDTypography>
              <Autocomplete
                options={filteredOptions}
                value={selectedPath}
                onChange={(event, newValue) => {
                  setSelectedPath(newValue)
                }}
                inputValue={searchInput}
                onInputChange={(event, newInputValue) => {
                  setSearchInput(newInputValue)
                }}
                getOptionLabel={(option) => option.label || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search for a path..."
                    variant="outlined"
                    fullWidth
                  />
                )}
                renderOption={(props, option) => (
                  <li {...props}>
                    <MDBox>
                      <MDTypography variant="body2" fontWeight="bold">
                        {option.label}
                      </MDTypography>
                      <MDTypography variant="caption" color="textSecondary">
                        {option.value}
                      </MDTypography>
                    </MDBox>
                  </li>
                )}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                noOptionsText="No paths found"
              />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Points</MDTypography>
              <MDInput label="Points" name="points" fullWidth defaultValue={data.points} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography
                variant="button"
                sx={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <p>Page Path</p>

                <FormControlLabel
                  control={<Checkbox name="custom_buttons" defaultChecked={data.custom_buttons} />}
                  label="Custom Buttons"
                />
              </MDTypography>

              <MDInput
                label="Page Path"
                name="page_path"
                fullWidth
                required
                defaultValue={data.page_path}
              />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Video Path</MDTypography>
              <MDInput
                label="Video Path"
                name="video_path"
                fullWidth
                required
                defaultValue={data.video_path}
              />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Status</MDTypography>
              <MDInput
                select
                name="status"
                fullWidth
                required
                SelectProps={{ native: true }}
                defaultValue={data.status}
              >
                <option value="Publish">Publish</option>
                <option value="Draft">Draft</option>
              </MDInput>
            </MDBox>

            <Stack direction="row" alignItems="center" spacing={2}>
              <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                Upload Image +
                <input hidden name="image" type="file" />
              </Button>
            </Stack>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeEditProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default EditModal